import React from 'react';
import ClientPrePaymentsSearchParams from './ClientPrePaymentsSearchParams';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ClientPrePaymentItem from '../../../Domain/ClientPrePaymentItem';
import ClientPrePaymentService from '../../../Services/ClientPrePaymentService';

export default class ClientPrePaymentsAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchItem: new ClientPrePaymentsSearchParams()
    };

    this.startSearch = this.startSearch.bind(this);
  }

  componentDidMount() {
    const searchItem = { ...this.state.searchItem };
    searchItem.PaymentListType = this.props.type;
    if (searchItem.PaymentListType !== this.state.searchItem.PaymentListType) this.setState({ searchItem });
  }

  startSearch(searchItem) {
    this.setState({ searchItem: { ...searchItem } });
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={ClientPrePaymentItem}
          serviceFunction={ClientPrePaymentService.GetPrePaymentsBySearching}
          convertDBItemsFunction={ClientPrePaymentService.ConvertPrePaymentDBItems}
          searchParamsType={ClientPrePaymentsSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          orderBy='ClDesc'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in client id, client name or invoice id...'
          errorCode='CPPA35'
        />
      </div>
    );
  }
}
